import React from 'react';
import PropTypes from 'prop-types';
import { TextField, MenuItem } from '@mui/material';
import useThemeStyles from '../../../../../hooks/useThemeStyles';

/**
 * Dumb chapter picker. An empty value means "follow the chapter currently in view".
 */
const ChapterSelect = ({ chapters, value, onChange, autoLabel }) => {
  const { colors } = useThemeStyles();

  return (
    <TextField
      select
      fullWidth
      size="small"
      label="Chapter"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        '& .MuiInputLabel-root': { color: colors.text.secondary },
        '& .MuiInputLabel-root.Mui-focused': { color: colors.interactive.primary },
        '& .MuiSelect-select': { color: colors.text.primary },
        '& .MuiOutlinedInput-root': {
          '& fieldset': { borderColor: colors.border.subtle },
          '&:hover fieldset': { borderColor: colors.interactive.primary },
          '&.Mui-focused fieldset': { borderColor: colors.interactive.primary },
        },
      }}
    >
      <MenuItem value="">{autoLabel}</MenuItem>
      {chapters.map((chapter) => (
        <MenuItem key={chapter.id || chapter._id} value={String(chapter.id || chapter._id)}>
          {chapter.name || 'Untitled Chapter'}
        </MenuItem>
      ))}
    </TextField>
  );
};

ChapterSelect.propTypes = {
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      _id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  autoLabel: PropTypes.string,
};

ChapterSelect.defaultProps = {
  chapters: [],
  value: '',
  autoLabel: 'Auto (chapter in view)',
};

export default ChapterSelect;
